module.exports = __webpack_public_path__ + "epdf-app/dashboard/batch/index-tab-TpRarbdY.html";